import axios, {AxiosResponse, CancelToken} from 'axios';
import {CANCEL} from 'redux-saga';

import Url from '../constants/Url';

class MyOverallHighlightsApi {
    getHighlights({value, ...params}) {
        const source = axios.CancelToken.source();
        const cancelToken: CancelToken = source.token;

        const request: Promise<AxiosResponse<string>> = axios
            .get(Url().GET_HIGHLIGHTS(value), {params, cancelToken})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getHighlights:', ex.message);
                throw ex;
            });

        request[CANCEL] = () => source.cancel();

        return request;
    }
}

export default new MyOverallHighlightsApi();
